/* eslint-disable jira/filename-case */
// code-reaper-ignore-file -- Uses different implementations for client and server.

import type {
	AnalyticsWebClient,
	InitAttrs,
} from '@jira/platform__observability-product-analytics-web-client-types';
import {
	getAnalyticsWebClient as browserGetAnalyticsWebClient,
	initAnalyticsWebClient as browserInitAnalyticsWebClient,
} from './main.tsx';
import {
	getAnalyticsWebClient as serverGetAnalyticsWebClient,
	initAnalyticsWebClient as serverInitAnalyticsWebClient,
} from './server.tsx';

export const getAnalyticsWebClient = (attrs?: InitAttrs): AnalyticsWebClient => {
	return __SERVER__ ? serverGetAnalyticsWebClient(attrs) : browserGetAnalyticsWebClient();
};

export const initAnalyticsWebClient = (
	attrs?: InitAttrs,
): Promise<AnalyticsWebClient> | boolean | undefined => {
	// oxlint-disable-next-line typescript/no-non-null-assertion
	return __SERVER__ ? serverInitAnalyticsWebClient(attrs) : browserInitAnalyticsWebClient(attrs!);
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type {
	ScreenEvent,
	UIEvent,
	TrackEvent,
	OperationalEvent,
	UnknownEvent,
	AnalyticsEvent,
} from '@jira/platform__observability-product-analytics-web-client-types';
